import type { AdminShopStatus } from '@agenda-facil/contracts';

export const currency = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  maximumFractionDigits: 0,
});

export const shortDate = new Intl.DateTimeFormat('pt-BR', {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
});

export const shortDateTime = new Intl.DateTimeFormat('pt-BR', {
  day: '2-digit',
  month: 'short',
  hour: '2-digit',
  minute: '2-digit',
});

export const adminStatusMeta: Record<
  AdminShopStatus,
  { label: string; tone: 'neutral' | 'success' | 'warning' | 'danger' }
> = {
  TRIALING: { label: 'Em teste', tone: 'warning' },
  PENDING_PAYMENT: { label: 'Pagamento pendente', tone: 'warning' },
  ACTIVE: { label: 'Ativa', tone: 'success' },
  PAST_DUE: { label: 'Em atraso', tone: 'danger' },
  CANCELED: { label: 'Cancelada', tone: 'neutral' },
  EXPIRED: { label: 'Expirada', tone: 'danger' },
  NO_SUBSCRIPTION: { label: 'Sem assinatura', tone: 'neutral' },
};
